// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sq-brand: #e63b11;
  --sq-brand-strong: #c9320c;
  --sq-brand-stronger: #a82a0a;
  --sq-brand-soft: #fdeee9;
  --sq-navy: #01426a;
  --sq-navy-deep: #012a45;
  --sq-navy-darker: #011f33;
  --sq-sky: #77c5d5;
  --sq-bg: #f3f5f8;
  --sq-surface: #ffffff;
  --sq-surface-2: #f8fafc;
  --sq-surface-3: #eef2f6;
  --sq-border: #e1e7ee;
  --sq-border-strong: #c8d1dc;
  --sq-text: #10212f;
  --sq-text-2: #43546a;
  --sq-text-3: #5a6b80;
  --sq-good: #067647;
  --sq-good-bg: #ecfdf3;
  --sq-good-line: #abefc6;
  --sq-warn: #a85606;
  --sq-warn-bg: #fff8eb;
  --sq-warn-line: #fbd98a;
  --sq-bad: #b42318;
  --sq-bad-bg: #fef3f2;
  --sq-bad-line: #fecdca;
  --sq-info: #01426a;
  --sq-info-bg: #eef7fc;
  --sq-info-line: #b6def0;
  --sq-neutral: #43546a;
  --sq-neutral-bg: #f1f4f8;
  --sq-neutral-line: #dde4ec;
  --sq-cat-available: #45b854;
  --sq-cat-ready: #f08a24;
  --sq-cat-complete: #3a9bb0;
  --sq-cat-in-use: #e9c400;
  --sq-cat-error: #b91c1c;
  --sq-cat-out-of-order: #6c757d;
  --sq-cat-unknown: #adb5bd;
  --sq-font: "Inter Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  --sq-radius-sm: 8px;
  --sq-radius: 12px;
  --sq-radius-lg: 16px;
  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);
  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);
  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);
  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);
  --sq-sidebar-w: 256px;
  --sq-topbar-h: 56px;
  --sq-bottomnav-h: 60px;
  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);
  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);
}

:root {
  --bs-body-font-family: var(--sq-font);
  --bs-body-font-size: 0.9375rem;
  --bs-body-line-height: 1.5;
  --bs-body-bg: var(--sq-bg);
  --bs-body-color: var(--sq-text);
  --bs-secondary-color: var(--sq-text-3);
  --bs-border-color: var(--sq-border);
  --bs-border-radius: var(--sq-radius-sm);
  --bs-primary: var(--sq-brand-strong);
  --bs-primary-rgb: 201, 50, 12;
  --bs-secondary: var(--sq-navy);
  --bs-secondary-rgb: 1, 66, 106;
  --bs-success: var(--sq-good);
  --bs-danger: var(--sq-bad);
  --bs-link-color: var(--sq-navy);
  --bs-link-color-rgb: 1, 66, 106;
  --bs-link-hover-color: var(--sq-brand-strong);
  --bs-link-hover-color-rgb: 201, 50, 12;
  --bs-code-color: var(--sq-navy);
}

html {
  text-size-adjust: 100%;
}

body {
  margin: 0;
  background: var(--sq-bg);
  color: var(--sq-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-feature-settings: "cv11", "ss03";
  overflow-x: clip;
}

h1, h2, h3, h4, h5, h6 {
  color: var(--sq-text);
  letter-spacing: -0.01em;
}

code, pre {
  font-family: var(--sq-mono);
}

button {
  font: inherit;
}

:focus-visible {
  outline: none;
  box-shadow: var(--sq-focus);
}

a, button, [role=button], label, select, summary {
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.btn {
  --bs-btn-font-weight: 600;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-padding-x: 0.875rem;
  --bs-btn-padding-y: 0.4375rem;
  --bs-btn-border-radius: var(--sq-radius-sm);
  --bs-btn-focus-box-shadow: var(--sq-focus);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  white-space: nowrap;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.btn-sm {
  --bs-btn-font-size: 0.8125rem;
  --bs-btn-padding-x: 0.7rem;
  --bs-btn-padding-y: 0.3125rem;
  --bs-btn-border-radius: var(--sq-radius-sm);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: var(--sq-brand-strong);
  --bs-btn-border-color: var(--sq-brand-strong);
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: var(--sq-brand-stronger);
  --bs-btn-hover-border-color: var(--sq-brand-stronger);
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: var(--sq-brand-stronger);
  --bs-btn-active-border-color: var(--sq-brand-stronger);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: var(--sq-brand-strong);
  --bs-btn-disabled-border-color: var(--sq-brand-strong);
}

.btn-outline-primary,
.btn-outline-secondary {
  --bs-btn-color: var(--sq-text);
  --bs-btn-bg: var(--sq-surface);
  --bs-btn-border-color: var(--sq-border-strong);
  --bs-btn-hover-color: var(--sq-navy);
  --bs-btn-hover-bg: var(--sq-surface-3);
  --bs-btn-hover-border-color: var(--sq-navy);
  --bs-btn-active-color: var(--sq-navy);
  --bs-btn-active-bg: var(--sq-surface-3);
  --bs-btn-active-border-color: var(--sq-navy);
  --bs-btn-disabled-color: var(--sq-text-3);
  --bs-btn-disabled-bg: var(--sq-surface);
  --bs-btn-disabled-border-color: var(--sq-border);
}

.btn-link {
  --bs-btn-color: var(--sq-navy);
  --bs-btn-hover-color: var(--sq-brand-strong);
  --bs-btn-active-color: var(--sq-brand-strong);
  --bs-btn-font-weight: 600;
}

.alert {
  --bs-alert-border-radius: var(--sq-radius-sm);
  --bs-alert-padding-y: 0.7rem;
  --bs-alert-padding-x: 0.9rem;
  font-size: 0.875rem;
  overflow-wrap: anywhere;
}

.alert-danger {
  --bs-alert-color: var(--sq-bad);
  --bs-alert-bg: var(--sq-bad-bg);
  --bs-alert-border-color: var(--sq-bad-line);
}

.alert-warning {
  --bs-alert-color: var(--sq-warn);
  --bs-alert-bg: var(--sq-warn-bg);
  --bs-alert-border-color: var(--sq-warn-line);
}

.alert-info {
  --bs-alert-color: var(--sq-info);
  --bs-alert-bg: var(--sq-info-bg);
  --bs-alert-border-color: var(--sq-info-line);
}

.form-control,
.form-select {
  --bs-border-radius: var(--sq-radius-sm);
  border-color: var(--sq-border-strong);
  font-size: 0.875rem;
}
.form-control:focus,
.form-select:focus {
  border-color: var(--sq-navy);
  box-shadow: var(--sq-focus);
}

@media (pointer: coarse), (max-width: 767px) {
  .btn,
  .btn-sm {
    min-height: 44px;
    --bs-btn-padding-x: 0.9rem;
  }
}
@media (max-width: 767px) {
  input:not([type=checkbox]):not([type=radio]),
  select,
  textarea {
    font-size: 16px !important;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
@media print {
  .sq-sidebar,
  .sq-topbar,
  .sq-bottomnav,
  .sq-footer {
    display: none !important;
  }
  .sq-main {
    margin: 0 !important;
    padding: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens.scss","webpack://./src/styles/base.scss"],"names":[],"mappings":"AAOA;EAGE,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EAGA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;EAGA,kBAAA;EACA,oBAAA;EACA,oBAAA;EAIA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0BAAA;EAGA,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yBAAA;EAGA;uCAAA;EAEA,sFAAA;EAGA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gDAAA;EACA,oFAAA;EACA,uDAAA;EACA,4CAAA;EAIA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kDAAA;EACA,4CAAA;ACxBF;;AAnDA;EACE,qCAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,+BAAA;EACA,sCAAA;EACA,mCAAA;EACA,uCAAA;EACA,oCAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,0BAAA;EACA,+BAAA;EACA,+BAAA;EACA,6CAAA;EACA,sCAAA;EACA,+BAAA;AAsDF;;AAnDA;EAEE,sBAAA;AAsDF;;AAnDA;EACE,SAAA;EACA,wBAAA;EACA,qBAAA;EACA,mCAAA;EACA,kCAAA;EACA,qCAAA;EACA,gBAAA;AAsDF;;AAnDA;EACE,qBAAA;EACA,uBAAA;AAsDF;;AAnDA;EACE,2BAAA;AAsDF;;AAnDA;EACE,aAAA;AAsDF;;AAnDA;EACE,aAAA;EACA,2BAAA;AAsDF;;AAlDA;EACE,0BAAA;EACA,wCAAA;AAqDF;;AAhDA;EACE,yBAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2CAAA;EACA,0CAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,kFAAA;AAmDF;;AAhDA;EACE,6BAAA;EACA,0BAAA;EACA,6BAAA;EACA,2CAAA;AAmDF;;AAhDA;EACE,oBAAA;EACA,mCAAA;EACA,6CAAA;EACA,0BAAA;EACA,2CAAA;EACA,qDAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,6BAAA;EACA,4CAAA;EACA,sDAAA;AAmDF;;AA/CA;;EAEE,8BAAA;EACA,8BAAA;EACA,8CAAA;EACA,oCAAA;EACA,sCAAA;EACA,2CAAA;EACA,qCAAA;EACA,uCAAA;EACA,4CAAA;EACA,yCAAA;EACA,uCAAA;EACA,gDAAA;AAkDF;;AA/CA;EACE,8BAAA;EACA,4CAAA;EACA,6CAAA;EACA,yBAAA;AAkDF;;AA/CA;EACE,6CAAA;EACA,4BAAA;EACA,4BAAA;EACA,mBAAA;EACA,uBAAA;AAkDF;;AA/CA;EACE,+BAAA;EACA,+BAAA;EACA,2CAAA;AAkDF;;AA/CA;EACE,gCAAA;EACA,gCAAA;EACA,4CAAA;AAkDF;;AA/CA;EACE,gCAAA;EACA,gCAAA;EACA,4CAAA;AAkDF;;AA/CA;;EAEE,uCAAA;EACA,qCAAA;EACA,mBAAA;AAkDF;AAhDE;;EACE,4BAAA;EACA,2BAAA;AAmDJ;;AA5CA;EACE;;IAEE,gBAAA;IACA,0BAAA;EA+CF;AACF;AA1CA;EACE;;;IAGE,0BAAA;EA4CF;AACF;AAzCA;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;EA2CF;AACF;AAvCA;EACE;;;;IAIE,wBAAA;EAyCF;EAtCA;IACE,oBAAA;IACA,qBAAA;EAwCF;AACF","sourcesContent":["// Design tokens — the single source of truth for colour, type, space and depth.\n// Every component reads these CSS variables; nothing else should hard-code a hex.\n\n// Breakpoints (Sass only — media queries can't read CSS variables).\n$bp-phone: 767px; // Up to here: single column, stacked tables, bottom sheets.\n$bp-shell: 991px; // Up to here: top bar + bottom nav instead of the sidebar.\n\n:root {\n  // Brand. `--sq-brand` is the logo orange, used for accents and large marks.\n  // `--sq-brand-strong` carries white text at AA contrast (the logo orange is 4.2:1).\n  --sq-brand: #e63b11;\n  --sq-brand-strong: #c9320c;\n  --sq-brand-stronger: #a82a0a;\n  --sq-brand-soft: #fdeee9;\n  --sq-navy: #01426a;\n  --sq-navy-deep: #012a45;\n  --sq-navy-darker: #011f33;\n  --sq-sky: #77c5d5;\n\n  // Surfaces and lines.\n  --sq-bg: #f3f5f8;\n  --sq-surface: #ffffff;\n  --sq-surface-2: #f8fafc;\n  --sq-surface-3: #eef2f6;\n  --sq-border: #e1e7ee;\n  --sq-border-strong: #c8d1dc;\n\n  // Text.\n  --sq-text: #10212f;\n  --sq-text-2: #43546a;\n  --sq-text-3: #5a6b80;\n\n  // Status tones. Reserved for state — never decoration — and always paired\n  // with a label or icon so meaning never rests on colour alone.\n  --sq-good: #067647;\n  --sq-good-bg: #ecfdf3;\n  --sq-good-line: #abefc6;\n  --sq-warn: #a85606;\n  --sq-warn-bg: #fff8eb;\n  --sq-warn-line: #fbd98a;\n  --sq-bad: #b42318;\n  --sq-bad-bg: #fef3f2;\n  --sq-bad-line: #fecdca;\n  --sq-info: #01426a;\n  --sq-info-bg: #eef7fc;\n  --sq-info-line: #b6def0;\n  --sq-neutral: #43546a;\n  --sq-neutral-bg: #f1f4f8;\n  --sq-neutral-line: #dde4ec;\n\n  // Machine states on the Status page.\n  --sq-cat-available: #45b854;\n  --sq-cat-ready: #f08a24;\n  --sq-cat-complete: #3a9bb0;\n  --sq-cat-in-use: #e9c400;\n  --sq-cat-error: #b91c1c;\n  --sq-cat-out-of-order: #6c757d;\n  --sq-cat-unknown: #adb5bd;\n\n  // Type.\n  --sq-font: \"Inter Variable\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace;\n\n  // Shape and depth.\n  --sq-radius-sm: 8px;\n  --sq-radius: 12px;\n  --sq-radius-lg: 16px;\n  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);\n  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);\n  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);\n  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);\n\n  // Shell. The bottom offset keeps content clear of the fixed nav and the\n  // iPhone home indicator.\n  --sq-sidebar-w: 256px;\n  --sq-topbar-h: 56px;\n  --sq-bottomnav-h: 60px;\n  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);\n  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);\n}\n","// Global reset on top of Bootstrap, plus Bootstrap's own variables mapped to our\n// tokens so any `.btn`, `.alert` or utility class picks up the brand.\n@import \"./tokens.scss\";\n\n:root {\n  --bs-body-font-family: var(--sq-font);\n  --bs-body-font-size: 0.9375rem;\n  --bs-body-line-height: 1.5;\n  --bs-body-bg: var(--sq-bg);\n  --bs-body-color: var(--sq-text);\n  --bs-secondary-color: var(--sq-text-3);\n  --bs-border-color: var(--sq-border);\n  --bs-border-radius: var(--sq-radius-sm);\n  --bs-primary: var(--sq-brand-strong);\n  --bs-primary-rgb: 201, 50, 12;\n  --bs-secondary: var(--sq-navy);\n  --bs-secondary-rgb: 1, 66, 106;\n  --bs-success: var(--sq-good);\n  --bs-danger: var(--sq-bad);\n  --bs-link-color: var(--sq-navy);\n  --bs-link-color-rgb: 1, 66, 106;\n  --bs-link-hover-color: var(--sq-brand-strong);\n  --bs-link-hover-color-rgb: 201, 50, 12;\n  --bs-code-color: var(--sq-navy);\n}\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\nbody {\n  margin: 0;\n  background: var(--sq-bg);\n  color: var(--sq-text);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-feature-settings: \"cv11\", \"ss03\";\n  overflow-x: clip;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  color: var(--sq-text);\n  letter-spacing: -0.01em;\n}\n\ncode, pre {\n  font-family: var(--sq-mono);\n}\n\nbutton {\n  font: inherit;\n}\n\n:focus-visible {\n  outline: none;\n  box-shadow: var(--sq-focus);\n}\n\n// Removes the 300ms tap delay and the grey iOS tap flash.\na, button, [role=\"button\"], label, select, summary {\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n// Bootstrap surfaces -------------------------------------------------------\n\n.btn {\n  --bs-btn-font-weight: 600;\n  --bs-btn-font-size: 0.875rem;\n  --bs-btn-padding-x: 0.875rem;\n  --bs-btn-padding-y: 0.4375rem;\n  --bs-btn-border-radius: var(--sq-radius-sm);\n  --bs-btn-focus-box-shadow: var(--sq-focus);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  white-space: nowrap;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.btn-sm {\n  --bs-btn-font-size: 0.8125rem;\n  --bs-btn-padding-x: 0.7rem;\n  --bs-btn-padding-y: 0.3125rem;\n  --bs-btn-border-radius: var(--sq-radius-sm);\n}\n\n.btn-primary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: var(--sq-brand-strong);\n  --bs-btn-border-color: var(--sq-brand-strong);\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: var(--sq-brand-stronger);\n  --bs-btn-hover-border-color: var(--sq-brand-stronger);\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: var(--sq-brand-stronger);\n  --bs-btn-active-border-color: var(--sq-brand-stronger);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: var(--sq-brand-strong);\n  --bs-btn-disabled-border-color: var(--sq-brand-strong);\n}\n\n// Orange marks the one primary action on a screen; everything else is neutral.\n.btn-outline-primary,\n.btn-outline-secondary {\n  --bs-btn-color: var(--sq-text);\n  --bs-btn-bg: var(--sq-surface);\n  --bs-btn-border-color: var(--sq-border-strong);\n  --bs-btn-hover-color: var(--sq-navy);\n  --bs-btn-hover-bg: var(--sq-surface-3);\n  --bs-btn-hover-border-color: var(--sq-navy);\n  --bs-btn-active-color: var(--sq-navy);\n  --bs-btn-active-bg: var(--sq-surface-3);\n  --bs-btn-active-border-color: var(--sq-navy);\n  --bs-btn-disabled-color: var(--sq-text-3);\n  --bs-btn-disabled-bg: var(--sq-surface);\n  --bs-btn-disabled-border-color: var(--sq-border);\n}\n\n.btn-link {\n  --bs-btn-color: var(--sq-navy);\n  --bs-btn-hover-color: var(--sq-brand-strong);\n  --bs-btn-active-color: var(--sq-brand-strong);\n  --bs-btn-font-weight: 600;\n}\n\n.alert {\n  --bs-alert-border-radius: var(--sq-radius-sm);\n  --bs-alert-padding-y: 0.7rem;\n  --bs-alert-padding-x: 0.9rem;\n  font-size: 0.875rem;\n  overflow-wrap: anywhere;\n}\n\n.alert-danger {\n  --bs-alert-color: var(--sq-bad);\n  --bs-alert-bg: var(--sq-bad-bg);\n  --bs-alert-border-color: var(--sq-bad-line);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--sq-warn);\n  --bs-alert-bg: var(--sq-warn-bg);\n  --bs-alert-border-color: var(--sq-warn-line);\n}\n\n.alert-info {\n  --bs-alert-color: var(--sq-info);\n  --bs-alert-bg: var(--sq-info-bg);\n  --bs-alert-border-color: var(--sq-info-line);\n}\n\n.form-control,\n.form-select {\n  --bs-border-radius: var(--sq-radius-sm);\n  border-color: var(--sq-border-strong);\n  font-size: 0.875rem;\n\n  &:focus {\n    border-color: var(--sq-navy);\n    box-shadow: var(--sq-focus);\n  }\n}\n\n// Touch ---------------------------------------------------------------------\n\n// Comfortable tap targets on anything that isn't a precise pointer.\n@media (pointer: coarse), (max-width: $bp-phone) {\n  .btn,\n  .btn-sm {\n    min-height: 44px;\n    --bs-btn-padding-x: 0.9rem;\n  }\n}\n\n// iOS zooms the page when a focused field is under 16px, so fields go to 16px\n// on phones. !important beats MUI's emotion styles and small variants.\n@media (max-width: $bp-phone) {\n  input:not([type=\"checkbox\"]):not([type=\"radio\"]),\n  select,\n  textarea {\n    font-size: 16px !important;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\n// Printing a report shouldn't include the app chrome.\n@media print {\n  .sq-sidebar,\n  .sq-topbar,\n  .sq-bottomnav,\n  .sq-footer {\n    display: none !important;\n  }\n\n  .sq-main {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
